<template>
  <div id="container-items-new" class="col-xs-12 noPadding">
    <table>
      <tr>
        <th>
          <div class="container-header-title">
            Nome file
          </div>
        </th>
        <th>
          <div class="container-header-title">
            Specifiche di stampa
          </div>
        </th>
        <th>
          <div class="container-header-title">
            Quantità
          </div>
        </th>
        <th>
          <div class="container-header-title">
            Data spedizione
          </div>
        </th>
        <th>
          <div class="clearfix noPadding container-header-title check-file">
            <div class="noPadding header-check-file">Check file (+5 &euro;)</div>
            <div class="noPadding info-check-file"
                 title="Verrà effettuato un controllo aggiuntivo riguardo ad un’eventuale corruzione del file e agli spessori minimi.">
              <!--              <div class="noPadding additional-price"></div>-->
              <icon name="elm-info"></icon>
            </div>
          </div>
        </th>
        <th>
          <div class="container-header-title">
            &nbsp;
          </div>
        </th>
        <th>
          <div class="container-header-title">
            &nbsp;
          </div>
        </th>
      </tr>

      <tr v-for="(item, index) in cartItems">
        <!-- Nome file -->
        <td>
          <div class="clearfix container-body-val file-name" v-on:click="updateProduct(item)">
            <div class="clearfix style-label">
              <div class="clearfix name-and-eye">
                <div class="clearfix name-file">{{item.file_name}}</div>
                <div class="clearfix eye-container">
                  <icon-loc name="elm-eye" class="icon-see-product"></icon-loc>
                </div>
              </div>
            </div>
            <div class="warning-text-container"
                 title="L’errore non è bloccante, procedi con l’ordine e i tecnici di Elmec 3D ti ricontatteranno al più presto.">
              <div class="warning-text">
                {{getTextFromArray(item.warning)}}
              </div>
            </div>
          </div>
        </td>
        <!-- Specifiche di stampa -->
        <td>
          <div class="clearfix container-body-val tech-spec">
            <div class="clearfix container-tech-spec">
              <div class="clearfix col-xs-offset-2">
                <span class="noPadding clearfix title-label-printer">Stampante:</span>
                <span class="noPadding clearfix label-print">{{getPrinterFromCode(item.printer)}}</span>
              </div>

              <div class="clearfix col-xs-offset-2">
                <span class="noPadding clearfix title-label-printer">Materiale:</span>
                <span class="noPadding clearfix label-print">
                  {{getMaterialFromCode(item.material)}}
                </span>
              </div>

              <div class="clearfix col-xs-offset-2">
                <span class="noPadding clearfix title-label-printer">Finitura:</span>
                <span class="noPadding clearfix label-print">
                  {{getPostProcessFromCode(item.post_process)}}
                </span>
              </div>
            </div>
          </div>
        </td>
        <!-- Quantità -->
        <td>
          <div class="clearfix container-body-val qty">
            <input class="noPadding text-center" type="number" name="quantity" min="1" v-model="item.quantity"
                   @blur="updateDataRow(item)">
          </div>
        </td>
        <!-- Data di spedizione -->
        <td>
          <div class="clearfix container-body-val prices" :key="keyPrices">
            <div class="col-xs-4 noPadding price" v-bind:class="{'selected': typeShipping.toString() === '2'}">
              <div v-if="index === 0" class="clearfix col-xs-12 noPadding date"
                   v-bind:class="{'selected': typeShipping.toString() === '2'}">
                <input type="radio" class="noPadding radio-shipment" name="shipment" value="2"
                       v-model="typeShipping">
                <div class="noPadding text-date">
                  15 giorni
                  <br>
                  lavorativi
                </div>
              </div>
              <div v-if="item.price.net3 > 0.00" class="noPadding col-xs-12 align-middle space-top"
                   v-bind:class="[{'first': index === 0}, {'visible-price': item.price.net3 > 0.00}]">
                <div class="same-font tot" v-two-dec>{{item.price.net3}}</div>
                <div class="price_single little-font">
                  <span v-two-dec>
                    {{item.price_single.net3}}
                  </span>
                  cad.
                </div>
              </div>
              <div v-else class="noPadding col-xs-12 align-middle space-top" v-bind:class="{'first': index === 0}">- -
                &euro;
              </div>
            </div>

            <div class="col-xs-4 noPadding price" v-bind:class="{'selected': typeShipping.toString() === '1'}">
              <div v-if="index === 0" class="clearfix col-xs-12 noPadding date"
                   v-bind:class="{'selected': typeShipping.toString() === '1'}">
                <input type="radio" class="noPadding radio-shipment" name="shipment" value="1"
                       v-model="typeShipping">
                <div class="noPadding text-date">
                  10 giorni
                  <br>
                  lavorativi
                </div>
              </div>
              <div v-if="item.price.net2 > 0.00" class="noPadding col-xs-12 align-middle space-top"
                   v-bind:class="[{'first': index === 0}, {'visible-price': item.price.net2 > 0.00}]">
                <div class="same-font tot" v-two-dec>{{item.price.net2}}</div>
                <div class="price_single little-font">
              <span v-two-dec>
                {{item.price_single.net2}}
              </span>
                  cad.
                </div>
              </div>
              <div v-else class="noPadding col-xs-12 align-middle space-top" v-bind:class="{'first': index === 0}">- -
                &euro;
              </div>
            </div>

            <div class="col-xs-4 noPadding price" v-bind:class="{'selected': typeShipping.toString() === '0'}">
              <div v-if="index === 0" class="clearfix col-xs-12 noPadding date"
                   v-bind:class="{'selected': typeShipping.toString() === '0'}">
                <input type="radio" class="noPadding radio-shipment" name="shipment" value="0"
                       v-model="typeShipping">
                <div class="noPadding text-date">
                  5 giorni
                  <br>
                  lavorativi
                </div>
              </div>
              <div v-if="item.price.net1 > 0.00" class="noPadding col-xs-12 align-middle space-top"
                   v-bind:class="[{'first': index === 0}, {'visible-price': item.price.net1 > 0.00}]">
                <div class="same-font tot" v-two-dec>{{item.price.net1}}</div>
                <div class="price_single little-font">
              <span v-two-dec>
                {{item.price_single.net1}}
              </span>
                  cad.
                </div>
              </div>
              <div v-else class="noPadding col-xs-12 align-middle space-top" v-bind:class="{'first': index === 0}">- -
                &euro;
              </div>
            </div>
          </div>
        </td>
        <!-- Verifica file -->
        <td>
          <div class="clearfix container-body-val">
            <input v-model="item.check_file" :id="'check_file' + index" class="checkbox" type="checkbox"
                   @click="selectCheck(item)">
            <label :for="'check_file' + index" class="checkbox-label"></label>
          </div>
        </td>
        <!-- Modifica -->
        <td>
          <div class="clearfix container-body-val">
            <a class="delete-product" v-on:click.stop="updateProduct(item)">
              <icon scale="1.2" class="item-modifica" name="elm-modifica"></icon>
            </a>
          </div>
        </td>
        <!-- Cestino -->
        <td>
          <div class="clearfix container-body-val">
            <a class="delete-product" v-on:click.stop="deleteProduct(item.id_stl)">
              <icon scale="1.2" class="item-delete" name="elm-cestino"></icon>
            </a>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  import {validatorMixin} from '../mixins/validatorMixin'

  const axios = require('axios')
  import {momentMixin} from '../mixins/momentMixin'
  import Bus from '@/components/Bus.js'
  import swal from 'sweetalert2'
  import {inputElmec} from 'elmec-elements'
  import {generalMixins} from '../mixins/generalMixins'

  let moment = require('moment')
  moment.locale('it')

  export default {
    name: 'ItemsNewNew',
    components: {Bus, swal, inputElmec},
    props: {
      printers: {type: Array},
      materials: {type: Array},
      postProcesses: {type: Array},
      changeToUpdate: {type: Number}
    },
    mixins: [momentMixin, validatorMixin, generalMixins],
    data () {
      return {
        cartItems: [],
        shipments: {
          'shipment1': this._addWeekdays(moment(), 5),
          'shipment2': this._addWeekdays(moment(), 10),
          'shipment3': this._addWeekdays(moment(), 15)
        },
        typeShipping: -1,
        keyPrices: 0
      }
    },
    watch: {
      typeShipping: function (val, oldVal) {
        // console.log('typeShipping cambia')
        this.updateShipment()
      },
      changeToUpdate: function () {
        this.loadItemsCart()
      }
    },
    mounted: function () {
      this.loadItemsCart()

      Bus.$on('upload-complete', () => {
        this.loadItemsCart()
      })
    },
    methods: {
      getIdCart: function () {
        return localStorage.getItem('id_cart')
      },
      loadItemsCart: function () {
        let id_cart = this.getIdCart()

        if (id_cart && id_cart !== '') {
          axios.get('/api/v1/carts/' + id_cart)
            .then((response) => {
              if (response.status === 200) {
                let cartItemsResponse = response.data.result
                if (cartItemsResponse.rows && cartItemsResponse.rows.length >= 0) {
                  this.cartItems = cartItemsResponse.rows
                  this.typeShipping = cartItemsResponse.shipment
                  // Aggiungo campo src image
                  // this.cartItems.forEach((ci) => {
                  //   ci.srcImg = 'static/img/img-loading.png'
                  // })

                  this.keyPrices++
                  this.updatePriceTot()
                }
              }
            })
            .catch(() => {
              this.resetSiteDueInvalidCart()
            })
        }
      },
      getPrinterLinkFromCode: function (val) {
        let link = ''
        for (let i = 0; i < this.printers.length; i++) {
          if (this.printers[i].ID === val.toString()) {
            link = this.printers[i].LinkDetail
            break
          }
        }
        return link
      },
      getMaterialLinkFromCode: function (val) {
        let link = ''

        for (let i = 0; i < this.materials.length; i++) {
          if (this.materials[i].ID === val.toString()) {
            if (this.materials[i].Title === 'PA12') {
              link = 'https://www.elmec.com/3d/risorse/documenti/materiali/pa12.pdf'
            } else if (this.materials[i].Title === 'PA12 CB') {
              link = 'https://www.elmec.com/3d/risorse/documenti/materiali/pa12_cb.pdf'
            }
            break
          }
        }

        return link
      },
      getPrinterFromCode: function (val) {
        let title = ''
        for (let i = 0; i < this.printers.length; i++) {
          if (this.printers[i].ID === val.toString()) {
            title = this.printers[i].Title
            break
          }
        }
        return title
      },
      getMaterialFromCode: function (val) {
        let title = ''

        for (let i = 0; i < this.materials.length; i++) {
          if (this.materials[i].ID === val.toString()) {
            title = this.materials[i].Title
            break
          }
        }
        return title
      },
      getPostProcessFromCode: function (val) {
        let title = ''
        for (let i = 0; i < this.postProcesses.length; i++) {
          if (this.postProcesses[i].ID === val.toString()) {
            title = this.postProcesses[i].Title
            break
          }
        }
        return title
      },
      deleteProduct: function (id_stl) {
        swal.fire({
          title: 'Sei sicuro?',
          text: 'Non potrai annullare l\'operazione',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#4285F4',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, rimuovi',
          cancelButtonText: 'Annulla'
        }).then((result) => {
          if (result.value) {
            axios.delete('/api/v1/carts/' + this.getIdCart() + '/products/' + id_stl)
              .then((response) => {
                if (response.status === 200) {
                  if (response.data.code === 0) {
                    this.loadItemsCart()
                  }
                }
              })
              .catch(() => {
                swal('Errore recupero informazioni', 'Prova a ricaricare la pagina. In caso di problemi contattati', 'error')
              })
          }
        })
      },
      updateProduct: function (item) {
        Bus.$emit('update_product', item)
        window.scrollTo({top: 90, behavior: 'smooth'})
      },
      updateShipment: function () {
        axios.put('/api/v1/carts/' + this.getIdCart() + '/shipment/' + this.typeShipping)
          .then((response) => {
            if (response.status === 200) {
              if (response.data.code === 20) {
                this.updatePriceTot()
              }
            }
          })
          .catch(() => {
            swal('Errore salvataggio informazioni', 'Prova a ricaricare la pagina. In caso di problemi contattati', 'error')
          })
      },
      updatePriceTot: function () {
        this.$emit('cart-items-tot')
      },
      selectCheck: function (item) {
        if (this.getBrowser().indexOf('Chrome') !== -1 || this.getBrowser().indexOf('Firefox') !== -1) {
          item.check_file = !item.check_file
        }
        this.updateDataRow(item)
      },
      updateDataRow: function (item) {
        if (item !== undefined) {
          let id_cart = this.getIdCart()
          let params

          if (!(this.isInteger(item.quantity))) {
            swal('Errore', 'Quantità selezionata non valida!', 'error')
            return
          }

          if (id_cart !== undefined && id_cart !== null && id_cart !== '') {
            params = {
              'id_cart': id_cart,
              'id_stl': item.id_stl,
              'printer': parseInt(item.printer),
              'material': parseInt(item.material),
              'post_process': parseInt(item.post_process),
              'quantity': item.toString() !== '' && item.quantity > 0 ? item.quantity : 1,
              'check_file': item.check_file ? 1 : 0
            }
          } else {
            params = {
              'id_stl': item.id_stl,
              'printer': parseInt(item.printer),
              'material': parseInt(item.material),
              'post_process': parseInt(item.post_process),
              'quantity': item.toString() !== '' && item.quantity > 0 ? item.quantity : 1,
              'check_file': item.check_file ? 1 : 0
            }
          }

          axios.post('/api/v1/carts/products/', params)
            .then((response) => {
              if (response.status === 201) {
                if (response.data.result.id_cart !== undefined && response.data.result.id_cart !== '') {
                  this.$emit('cart-items-tot')
                  Bus.$emit('upload-complete')
                }
              }
            })
            .catch(() => {
              this.loadItemsCart()
            })
        }
      },
      getBrowser: function () {
        let c = navigator.userAgent.search('Chrome')
        let f = navigator.userAgent.search('Firefox')
        let m8 = navigator.userAgent.search('MSIE 8.0')
        let m9 = navigator.userAgent.search('MSIE 9.0')
        let browser = ''
        if (c > -1) {
          browser = 'Chrome'
        }
        if (f > -1) {
          browser = 'Firefox'
        }
        if (m9 > -1) {
          browser = 'MSIE 9.0'
        }
        if (m8 > -1) {
          browser = 'MSIE 8.0'
        }
        if (/Edge/.test(navigator.userAgent)) {
          browser = 'Edge'
        }
        return browser
      },
      getTextFromArray: function (warning) {
        let arrErr = JSON.parse(warning.replace(/'/g, '"'))
        let strErrs = ''

        if (arrErr.length > 0) {
          strErrs = 'Il file caricato necessita un check aggiuntivo'
        }
        // Con questo ottengo il messaggio di warning che mi arriva da sharepoint
        // arrErr.forEach(e => {
        //   strErrs += e.Message + ' '
        // })

        return strErrs
      }

    }
  }
</script>

<style lang="less">
  #container-items-new {
    .style-label {
      color: #424242;
      font-size: 12px;
      font-family: "Open Sans", sans-serif;

      .name-and-eye {
        display: flex;
        display: -ms-flexbox;
        justify-content: center;

        .name-file {
          float: left;
          margin-right: 10px;
          padding: 10px;
          padding-top: 0;
        }

        .eye-container {
          float: left;
          padding-top: 2px;

          .icon-see-product {
            display: none;
          }
        }
      }
    }

    .same-font {
      font-size: 14px;

      &.tot {
        font-weight: bold;
      }
    }

    .little-font {
      font-size: 10px;
    }

    .container-header-title {
      &.check-file {
        min-width: 145px;
        display: flex;
        display: -ms-flexbox;
        justify-content: center;

        .header-check-file {
          float: left;
          padding-top: 8px;
          padding-left: 11px;
        }

        .info-check-file {
          float: left;
          padding: 0;
          padding-bottom: 8px;
          padding-top: 8px;

          .additional-price {
            float: left;
          }
        }
      }
    }

    table {
      width: 100%;

      th {
        background-color: #efefef;
        border: 3px solid white;

        div {
          height: 100%;
          min-width: 40px;
          background-color: #efefef;
          text-align: center;
          padding: 10px;
          font-weight: bold;
          font-size: 12px;
          color: #4285F4;
        }
      }

      td {
        background-color: #f9f9f9;
        border: 3px solid white;
        height: 110px;
        /*border-top: 0;*/
        /*border-bottom: 0;*/
        border-top: none;
      }

      .shipping-row-column {
        height: 70px;
      }

      .container-body-val {
        text-align: center;
        padding: 20px;

        &.file-name {
          padding-left: 0;
          padding-right: 0;
          cursor: pointer;

          &:hover {
            .style-label {
              color: #4285F4;

              .name-and-eye {
                .eye-container {
                  .icon-see-product {
                    display: inline-block;
                    color: #4285F4;
                  }
                }
              }
            }
          }
        }

        &.tech-spec {
          display: flex;
          display: -ms-flexbox;
          justify-content: center;
          padding: 0;

          .title-label-printer, .label-print {
            color: #333;
            font-size: 12px;
            text-align: left;
          }

          .title-label-printer {
            font-weight: bold;
            margin-right: 10px;
          }
        }

        &.qty {
          display: flex;
          display: -ms-flexbox;
          justify-content: center;

          input {
            font-size: 12px;
            width: 80px;
            margin: 0;
            background-color: transparent;
            border-bottom: 1px solid #fbbc05;
            height: 33px;
            float: left;

            &:focus {
              border: none;
              border-bottom: 1px solid #fbbc05;
            }
          }
        }

        &.shipping-date {
          padding: 0;

          .date {
            padding-top: 10px;

            input {
              display: inline-block;
              float: left;
              margin: 10px;
            }

            &.selected {
              background-color: #fbbc05;
            }

            &.my-col {
              width: 33.3%;
              float: left;
            }

            .text-date {
              color: #626366;
              font-size: 12px;
              font-weight: bold;
              padding: 0;
              float: left;
            }
          }
        }

        &.prices {
          padding: 0;
          height: 100%;

          &.with-date {
            height: 42px;
          }

          .price {
            padding: 10px 0;
            height: 100%;
            display: table;

            &.selected {
              background-color: #fbbc05;
            }

            .align-middle {
              display: table-cell;
              vertical-align: middle;

              &.space-top {
                padding-top: 40%;

                &.first {
                  padding-top: 20%;

                  &.visible-price {
                    padding-top: 12%;
                  }
                }

                &.visible-price {
                  padding-top: 30%;
                }
              }
            }

            .date {
              display: flex;
              display: -ms-flexbox;
              justify-content: center;
              padding-top: 5px;

              &.selected {
                background-color: #fbbc05;
              }

              .radio-shipment {
                display: inline-block;
                float: left;
                margin-right: 6px;
                margin-top: 10px;
              }

              .text-date {
                color: #626366;
                font-size: 12px;
                font-weight: bold;
                padding: 0;
                float: left;
                text-transform: lowercase;
              }
            }
          }
        }

        .container-tech-spec {
          width: 290px;

          .title-label-printer {
            font-weight: bold;
            font-size: 12px;
            float: left;
          }

          .label-print {
            float: left;
          }
        }

        .warning-text-container {
          display: flex;
          display: -ms-flexbox;
          justify-content: center;

          .warning-text {
            font-size: 13px;
            color: #f7bc33;
            max-width: 265px;
          }
        }

        .checkbox-label {
          &::after {
            border: none;
            background-color: transparent;
          }
        }

        .delete-product {
          cursor: pointer;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ItemsNewNew.vue